import React, {Component} from 'react';
import './Home.css';

export default class Home extends Component {
    render() {
        return (
            <div className="home">
                <address className="home__footer-address">
                    Av. Dr. Chucri Zaidan, 296, conj. 231 <span className="no-desktop">—</span> <br className="no-mobile" /> 
                    São Paulo - SP — Vl. Cordeiro — CEP 04583-110, Brazil. <br /><br />
                    Telefone: <strong>+55 (11) 5095-1609</strong><br className="no-desktop" /> Fax: <strong>+55 (11) 5095-3499</strong>
                </address>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/views/Home.js